import axios from "axios";
import { useAuth } from "./auth.service";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API;

export const usePermanentTokenService = () => {
  const { user } = useAuth();

  const getAuthHeaders = () => ({
    "Content-Type": "application/json",
    "x-access-token": user?.accessToken,
  });

  const getPermanentToken = async () => {
    if (!user || !user.accessToken) {
      throw new Error("User not authenticated");
    }

    try {
      const response = await axios.get(
        `${API_BASE_URL}/auth/permanent-token`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // No token set for this user
        return null;
      }
      console.error("Error loading permanent token:", error);
      throw error;
    }
  };

  const generatePermanentToken = async () => {
    if (!user || !user.accessToken) {
      throw new Error("User not authenticated");
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/auth/permanent-token`,
        {},
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      console.error("Error generating permanent token:", error);
      throw error;
    }
  };

  return {
    getPermanentToken,
    generatePermanentToken,
  };
};

